import React from "react";
import { Typography } from "@material-ui/core";
import styled from "styled-components";
import * as PropTypes from "prop-types";

const StyledTableCss = styled.table`
  margin: 0.5rem auto 0 auto;
  text-align: left;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 0.5rem;
  padding: 1rem;
`;
const StyledTd = styled.td`
  border-bottom: 1px solid #ddd;
  padding: 0.3rem 0.5rem;
`;


const UserFavorites = ({ data }) => {
  return (
    <Typography variant="body1" component="span">
      <Typography variant="subtitle1" component="h3" align="center">Your Favorites</Typography>
      <StyledTableCss>
        <tbody>
        <tr>
          <StyledTd>TOP3 All-Time Favorite Games</StyledTd>
          <StyledTd>{`${data.top3AllTimeGames.map(item => ` ${item}`)}`}</StyledTd>
        </tr>
        <tr>
          <StyledTd>TOP3 Favorite Indie Games</StyledTd>
          <StyledTd>{`${data.top3IndieGames.map(item => ` ${item}`)}`}</StyledTd>
        </tr>
        <tr>
          <StyledTd>Favorite Genres</StyledTd>
          <StyledTd>{`${data.favoriteGenres.map(item => ` ${item}`)}`}</StyledTd>
        </tr>
        <tr>
          <StyledTd>Favorite Settings and Themes</StyledTd>
          <StyledTd>{`${data.favoriteSettings.map(item => ` ${item}`)}`}</StyledTd>
        </tr>
        </tbody>
      </StyledTableCss>
    </Typography>
  );
};
UserFavorites.propTypes = {
  data: PropTypes.shape({
    top3AllTimeGames: PropTypes.array.isRequired,
    top3IndieGames: PropTypes.array.isRequired,
    favoriteGenres: PropTypes.array.isRequired,
    favoriteSettings: PropTypes.array.isRequired,
  }).isRequired,
};

export default UserFavorites;